import React from 'react';
import Img from '../common/Img';
import FavoriteTournamentButton from '../common/favorite-tournaments/FavoriteTournamentButton';

export default function TournamentHeader(props) {
    return (
        <div className="c_29">
            <div className="c_29_1">
                <span className={"c_29_1_1 " + props.icon}></span>
                <span className="c_29_1_2">{props.desc}</span>
                <Img className="c_29_1_3" src="icon_chevron.svg" height="16px" width="16px" data-rotate="270" />
            </div>
            <FavoriteTournamentButton id={props.uniqueId} />
        </div>
    );
}
